module.exports = __webpack_public_path__ + "img/ic_32_workout_item_intensity-high.f7a8ad46.svg";